export enum MessageStatusEnum{
     'PENDING',
     'SENT',
     'DELIVERED',
     'READ',
     'FAIL'
}